import { render } from "./home-category.vue?vue&type=template&id=3b2ab590&scoped=true"
import script from "./home-category.vue?vue&type=script&lang=js"
export * from "./home-category.vue?vue&type=script&lang=js"

import "./home-category.vue?vue&type=style&index=0&id=3b2ab590&scoped=true&lang=less"

import exportComponent from "G:\\PRO\\fuvview\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3b2ab590"]])

export default __exports__